import {
  Button,
} from '@mantine/core';
import {
  createFileRoute,
} from '@tanstack/react-router';
import {
  useAuth,
} from 'react-oidc-context';
export const Route = createFileRoute('/_app/_landing/solutions')({
  component: RouteComponent,
});

function RouteComponent() {
  const auth = useAuth();
  return (
    <>
      <div>
        <div
          style={ {
            marginTop: '9vw',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          } }
        >
          <p
            style={ {
              fontSize: '2.8vw',
              fontWeight: '400',
              color: 'rgb(255, 255, 255, 0.9)',
              letterSpacing: '0.05vw',
            } }
          >
            Solutions That Drive Success.
          </p>
          <p
            style={ {
              fontWeight: '400',
              color: 'rgb(255, 255, 255, 0.7)',
              fontSize: '2.5vw',
              width: '47vw',
              marginTop: '0.5vw',
              lineHeight: '1.8vw',
              letterSpacing: '0.05vw',
              textAlign: 'center',
            } }
          >
            Transform Your Workflow.
          </p>
          <p
            style={ {
              fontWeight: '300',
              color: 'rgb(255, 255, 255, 0.7)',
              fontSize: '0.9vw',
              width: '40vw',
              marginTop: '3vw',
              lineHeight: '1.8vw',
            } }
          >
            Specia Accountant is a cloud-based platform designed to
            streamline and enhance tax reporting for accountants.
            Leveraging advanced AI technology, it automates ATO report
            preparation and integrates seamlessly with accounting
            software, reducing time spent on repetitive tasks and
            improving accuracy.
          </p>
        </div>
      </div>
      <div
        style={ {
          width: '100%',
          padding: '0 2vw',
        } }
      >
        <div
          style={ {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '5vw',
          } }
        >
          <div
            style={ {
              display: 'flex',
              flexDirection: 'row',
              backgroundColor: 'rgb(255, 255, 255, 0.025)',
              padding: '2vw',
              borderRadius: '1vw',
              alignItems: 'center',
              flex: 1,
              marginRight: '2.5vw',
            } }
          >
            <div
              style={ {
                padding: '2vw',
                flex: 5,
                paddingLeft: '2vw',
                textAlign: 'left',
              } }
            >
              <p
                style={ {
                  fontSize: '2.0vw',
                  fontWeight: '400',
                  color: 'rgb(255, 255, 255, 0.9)',
                  marginBottom: '1vw',
                } }
              >
                Gary
              </p>
              <p
                style={ {
                  fontSize: '1.3vw',
                  fontWeight: '300',
                  color: 'rgb(255, 255, 255, 0.8)',
                  marginBottom: '2vw',
                } }
              >
                Workpaper Generation Service
              </p>
              <ul
                style={ {
                  paddingLeft: '1vw',
                } }
              >
                <li
                  style={ {
                    fontSize: '0.9vw',
                    lineHeight: '1.6vw',
                    fontWeight: '300',
                    color: 'rgb(255, 255, 255, 0.7)',
                    marginBottom: '1vw',
                  } }
                >
                  Generate fully customizable workpapers by fetching data
                  directly from ATO, Xero, and MYOB for precise tax
                  reporting.
                </li>
                <li
                  style={ {
                    fontSize: '0.9vw',
                    lineHeight: '1.6vw',
                    fontWeight: '300',
                    color: 'rgb(255, 255, 255, 0.7)',
                    marginBottom: '1vw',
                  } }
                >
                  Produce accurate, tailored reports with ease, reducing
                  manual data entry and minimizing potential errors.
                </li>
                <li
                  style={ {
                    fontSize: '0.9vw',
                    lineHeight: '1.6vw',
                    fontWeight: '300',
                    color: 'rgb(255, 255, 255, 0.7)',
                    marginBottom: '1vw',
                  } }
                >
                  Free up valuable time for accountants to focus on client
                  insights, analysis, and strategic success.
                </li>
                <li
                  style={ {
                    fontSize: '0.9vw',
                    lineHeight: '1.6vw',
                    fontWeight: '300',
                    color: 'rgb(255, 255, 255, 0.7)',
                    marginBottom: '1vw',
                  } }
                >
                  Simplify the reporting process for accountants, saving
                  time and effort while increasing efficiency.
                </li>
              </ul>
              <div
                style={ {
                  textAlign: 'center',
                  width: '100%',
                } }
              >
                <Button
                  onClick={ () => {
                    auth.signinRedirect();
                  } }
                >
                  Explore
                </Button>
              </div>
            </div>
          </div>
          <div
            style={ {
              display: 'flex',
              flexDirection: 'row',
              backgroundColor: 'rgb(255, 255, 255, 0.025)',
              padding: '2vw',
              borderRadius: '1vw',
              alignItems: 'center',
              flex: 1,
            } }
          >
            <div
              style={ {
                padding: '2vw',
                flex: 5,
                paddingLeft: '2vw',
                textAlign: 'left',
              } }
            >
              <p
                style={ {
                  fontSize: '2.0vw',
                  fontWeight: '400',
                  color: 'rgb(255, 255, 255, 0.9)',
                  marginBottom: '1vw',
                } }
              >
                Scout
              </p>
              <p
                style={ {
                  fontSize: '1.3vw',
                  fontWeight: '300',
                  color: 'rgb(255, 255, 255, 0.8)',
                  marginBottom: '2vw',
                } }
              >
                ATO Data Retrieval Service
              </p>
              <ul
                style={ {
                  paddingLeft: '1vw',
                } }
              >
                <li
                  style={ {
                    fontSize: '0.9vw',
                    lineHeight: '1.6vw',
                    fontWeight: '300',
                    color: 'rgb(255, 255, 255, 0.7)',
                    marginBottom: '1vw',
                  } }
                >
                  Retrieve ATO reports, such as activity statements and
                  income tax summaries, for multiple clients with a single
                  click.
                </li>
                <li
                  style={ {
                    fontSize: '0.9vw',
                    lineHeight: '1.6vw',
                    fontWeight: '300',
                    color: 'rgb(255, 255, 255, 0.7)',
                    marginBottom: '1vw',
                  } }
                >
                  Automate data retrieval to boost productivity and
                  improve accuracy in tax reporting.
                </li>
                <li
                  style={ {
                    fontSize: '0.9vw',
                    lineHeight: '1.6vw',
                    fontWeight: '300',
                    color: 'rgb(255, 255, 255, 0.7)',
                    marginBottom: '1vw',
                  } }
                >
                  Access critical client data quickly, enabling
                  accountants to focus on analysis and advisory tasks.
                </li>
                <li
                  style={ {
                    fontSize: '0.9vw',
                    lineHeight: '1.6vw',
                    fontWeight: '300',
                    color: 'rgb(255, 255, 255, 0.7)',
                    marginBottom: '1vw',
                  } }
                >
                  Streamline workflows, reducing time spent on repetitive
                  tasks across client accounts.
                </li>
              </ul>
              <div
                style={ {
                  textAlign: 'center',
                  width: '100%',
                } }
              >
                <Button
                  onClick={ () => {
                    auth.signinRedirect();
                  } }
                >
                  Explore
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
